<template>
  <div>
    <div :class="drawer">
      <router-link class="navbar-logo" :to="'/'" tag="div">
        <img
          src="@/assets/logo-white.png"
          alt="brand-logo"
          class="navbar-logo-image"
        />
      </router-link>

      <div class="nav">
        <div class="nav-menu">
          <ul class="nav-menu-links">
            <!-- <router-link
              id="home-link"
              :to="'/'"
              exact
              active-class="nav-active"
              tag="li"
              class="nav-menu-links-link"
            >
              {{ $t("home") }}
            </router-link> -->
            <a
              id="about-link"
              :href="'https://routeline.com/pages/about'"
              exact
              active-class="nav-active"
              tag="li"
              class="nav-menu-links-link"
            >
              <!-- {{ $t("about") }} -->
              What is Route Line
            </a>
            <router-link
              id="membership-link"
              class="nav-menu-links-link"
              exact
              :to="'/membership'"
              active-class="nav-active"
              tag="li"
            >
              {{ $t("membership") }}
            </router-link>
            <a
              id="vehicle-link"
              class="nav-menu-links-link"
              :href="'https://routeline.com/pages/our-fleet'"
              active-class="nav-active"
              tag="li"
            >
              {{ $t("vehicles") }}
            </a>
            <a
              id="vehicle-link"
              :href="'https://routeline.com/collections/shop'"
              exact
              active-class="nav-active"
              tag="li"
              class="nav-menu-links-link"
            >
              <!-- {{ $t("vehicles") }} -->
              Gear
            </a>
          </ul>
        </div>
        <div class="nav-button">
          <v-btn v-if="!user" :to="'/login'" rounded color="primary" id="mobile-create-account">
            Create Account/Sign-in
          </v-btn>
          <v-menu offset-y v-else>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" v-bind="attrs" v-on="on" text>
                <v-icon>mdi-account</v-icon> {{ getDisplayName }}
              </v-btn>
            </template>
            <v-list class="pa-0">
              <v-list-item class="pa-1 pt-0 pb-0">
                <v-btn text color="primary" to="/profile" id="mobile-profile-btn" dark>
                  Profile
                </v-btn>
              </v-list-item>
              <v-list-item class="pa-1 pt-0 pb-0">
                <v-btn text color="primary" to="/trips" id="mobile-trip-btn" dark> Trips </v-btn>
              </v-list-item>
              <v-list-item class="pa-1 pt-0 pb-0">
                <v-btn text color="primary" id="mobile-logout-btn" dark @click="$root.logout()">
                  Logout
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </div>
    <div :class="backdrop" @click="$emit('click')"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import Button from '../buttons/Button.vue'

export default {
  props: ["toggler"],
  computed: {
    backdrop() {
      return this.toggler ? "dm-backdrop" : "dm-backdrop-hide";
    },
    drawer() {
      return this.toggler ? "dm-mobile-show" : "dm-mobile";
    },
    ...mapGetters({
      user: "getUser",
    }),
    getDisplayName() {
      return this.user?.displayName;
    },
  },
  methods: {},
  components: {
    // Button,
  },
};
</script>

<style scoped lang="scss">
.navbar-logo {
  background: var(--primary-color);
  padding: 20px;
  width: 240px;
  clip-path: polygon(0 0, 100% 0, 81% 100%, 0% 100%);

  &-image {
    width: 150px;
  }
}
.dm-mobile {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  transform: translateX(-100%);
  background: var(--light);
  width: 75%;
  z-index: 999;
  transition: all 0.3s ease;
}
.dm-mobile-show {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  transform: translateX(0);
  background: var(--light);
  width: 75%;
  z-index: 999;
  transition: all 0.5s ease;
}
.dm-backdrop {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 99;
  transform: translateX(0);
  transition: all 0.3s ease;
}
.dm-backdrop-hide {
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 99;
  transform: translateX(-100%);
  transition: all 0.5s ease;
}

.nav {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 30px;
  row-gap: 20px;

  &-menu {
    transition: all 0.3s ease;
    &-links {
      display: flex;
      flex-direction: column;
      column-gap: 25px;

      &-link {
        list-style-type: none;
        cursor: pointer;
        transition: all 0.3s ease;
        position: relative;
        padding: 10px 0;
        text-decoration: none;

        &:hover {
          color: var(--primary-color);
          text-decoration: none;
        }
      }
    }
  }
  &-button {
    display: flex;
    align-items: center;
    column-gap: 20px;
    transition: all 0.3s ease;
    padding: 25px 20px;

    &-image {
      width: 35px;
      cursor: pointer;
    }
  }

  &-active {
    color: var(--primary-color);

    // &::after {
    //   position: absolute;
    //   content: '';
    //   display: block;
    //   width: 100%;
    //   height: 2px;
    //   background: var(--primary-color);
    //   transition: all 0.3s ease;
    // }
  }
}
</style>
